import { lazy } from 'react';

// ** Authentication Pages
export const PreRegister = lazy(
    () => import('features/preRegister')
);
export const Register = lazy(
    () => import('features/register')
);

export const ActivateUser = lazy(
    () => import('features/activeUser')
);

// ** Authentication Login Callback
export const AuthenticationLoginCallback = lazy(
    () =>
        import(
            'features/authentication/components/AuthenticationLogin'
        )
);

export const AuthenticationLoginErrors = lazy(
    () =>
        import(
            'features/authentication/components/AuthenticationLoginError'
        )
);

// ** Invitation
export const Invitation = lazy(
    () => import('features/invitation')
);

// ** GP Portal Routes
export const GPPortal = lazy(
    () => import('features/gpPortal')
);

// ** Upload Documents Pages
export const UploadDocuments = lazy(
    () => import('features/uploadDocuments')
);
